import React, { Component } from "react";
import { Select } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import { cargarSucursales } from "../cmmsComun";

const { Option } = Select;

// Unidades (cliente y, si tiene, sucursal) que se visitan en un viaje.
// value: [{ clienteId, direccionId }]
class UnidadesViajeCMMS extends Component {
    state = { sucursales: {} }; // clienteId -> [{ _id, nombre }]

    componentDidMount() {
        (this.props.value || []).forEach((u) => this.cargar(u.clienteId));
    }

    componentDidUpdate(prev) {
        if (prev.value !== this.props.value) (this.props.value || []).forEach((u) => this.cargar(u.clienteId));
    }

    cargar = async (clienteId) => {
        if (!clienteId || this.state.sucursales[clienteId]) return;
        this.setState((s) => ({ sucursales: { ...s.sucursales, [clienteId]: [] } }));
        const lista = await cargarSucursales(this.props, clienteId);
        this.setState((s) => ({ sucursales: { ...s.sucursales, [clienteId]: lista } }));
    };

    cambiar = (i, cambios) => this.props.onChange((this.props.value || []).map((u, j) => (j === i ? { ...u, ...cambios } : u)));

    render() {
        const lista = this.props.value || [];
        return (
            <div>
                {lista.map((u, i) => {
                    const sucursales = this.state.sucursales[u.clienteId] || [];
                    return (
                        <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
                            <div style={{ flex: 3, minWidth: 0 }}>
                                <SelectClientesItem
                                    empresaId={this.props.empresaId}
                                    headersToken={this.props.headersToken}
                                    width="100%"
                                    placeholder="Cliente"
                                    value={u.clienteId || undefined}
                                    onChange={(clienteId) => {
                                        this.cambiar(i, { clienteId: clienteId || null, direccionId: null });
                                        this.cargar(clienteId);
                                    }}
                                />
                            </div>
                            <Select
                                style={{ flex: 2, minWidth: 0 }}
                                allowClear
                                placeholder={u.clienteId ? (sucursales.length ? "Sucursal (opcional)" : "Sin sucursales") : "Sucursal"}
                                disabled={!u.clienteId || !sucursales.length}
                                value={u.direccionId || undefined}
                                onChange={(direccionId) => this.cambiar(i, { direccionId: direccionId || null })}
                            >
                                {sucursales.map((s) => (
                                    <Option key={s._id} value={s._id}>
                                        {s.nombre}
                                    </Option>
                                ))}
                            </Select>
                            <ButtonItem type="default" htmlType="button" rojo lessTime icon={<DeleteOutlined />} onClick={() => this.props.onChange(lista.filter((_, j) => j !== i))} />
                        </div>
                    );
                })}
                <ButtonItem type="dashed" htmlType="button" blanco lessTime icon={<PlusOutlined />} onClick={() => this.props.onChange([...lista, { clienteId: null, direccionId: null }])}>
                    Agregar unidad
                </ButtonItem>
            </div>
        );
    }
}

export default UnidadesViajeCMMS;
